/**
 * BillingPage — Settings → Billing & Subscriptions (T35.7.2.1).
 *
 * The single canonical home for managing the household's support: the
 * development-support donation + each backed idea. The acquisition entry points
 * (donate banner, back-an-idea CTA, the ☰ account drawer, the Feedback-tab menu)
 * deep-link in; they don't host their own manage UI.
 *
 * Composes the subscriptions module's `SubscriptionsList` inside the standard
 * `SettingsLayover` chrome (history-aware Back + the surface tile + the neutral
 * band). The list + cancel questionnaire + dormant "pay another way" all live in
 * `SubscriptionsList`; this page just frames it.
 */

import { SettingsLayover } from './SettingsLayover';
import { SubscriptionsList } from '../subscriptions/SubscriptionsList';

export function BillingPage(): JSX.Element {
  return (
    <SettingsLayover
      icon="card"
      title="Billing & subscriptions"
      backLabel="Back"
      testId="settings-billing"
      band={{
        variant: 'neutral',
        children: (
          <span>
            Everything you support here in one place — your development support and the ideas
            you’ve backed. Change the amount or cadence, or cancel anytime — canceling is
            reversible.
          </span>
        ),
      }}
    >
      <SubscriptionsList />
    </SettingsLayover>
  );
}
